import { DrawRewardTypeEnum } from "@/api/backofficeRest/generated/model"

export const REWARD_TYPE_LABELS: Record<DrawRewardTypeEnum, string> = {
  [DrawRewardTypeEnum.ACCOUNT_CREDIT]: "Account Credit",
  [DrawRewardTypeEnum.ACCOUNT_CREDIT_10_POUNDS]: "Account Credit (£10)",
  [DrawRewardTypeEnum.ACCOUNT_CREDIT_20_POUNDS]: "Account Credit (£20)",
  [DrawRewardTypeEnum.EV_CHARGER]: "EV Charger",
  [DrawRewardTypeEnum.EV_CHARGER_CREDIT]: "EV Charger Credit",
  [DrawRewardTypeEnum.HOMETREE]: "Boiler Service (Hometree)",
  [DrawRewardTypeEnum.YEAR_OF_ENERGY]: "Year of Energy",
  [DrawRewardTypeEnum.YEAR_OF_ENERGY_LEGACY]: "Year of Energy (legacy)",
  [DrawRewardTypeEnum.VOUCHER]: "Voucher",
}

export const EDITABLE_REWARD_TYPES: DrawRewardTypeEnum[] = [
  DrawRewardTypeEnum.ACCOUNT_CREDIT,
  DrawRewardTypeEnum.YEAR_OF_ENERGY,
  DrawRewardTypeEnum.EV_CHARGER,
  DrawRewardTypeEnum.HOMETREE,
  DrawRewardTypeEnum.VOUCHER,
]

// Types that take a single creditValuePence (> 0) input. EV_CHARGER / HOMETREE /
// VOUCHER / YEAR_OF_ENERGY_LEGACY are physical/manual/legacy prizes the BE requires to be null;
// YEAR_OF_ENERGY is configured with single-/dual-fuel values instead (see
// PER_FUEL_REWARD_TYPES). Mirrors PrizeDrawReward.validateReward.
const CREDIT_VALUE_REWARD_TYPES: ReadonlySet<DrawRewardTypeEnum> = new Set([
  DrawRewardTypeEnum.ACCOUNT_CREDIT,
  DrawRewardTypeEnum.ACCOUNT_CREDIT_10_POUNDS,
  DrawRewardTypeEnum.ACCOUNT_CREDIT_20_POUNDS,
  DrawRewardTypeEnum.EV_CHARGER_CREDIT,
])

// Types configured with single- and dual-fuel values (SINGLE_FUEL_PENCE +
// DUAL_FUEL_PENCE) instead of a single creditValuePence — the per-winner amount
// is resolved by the account's fuel count at award.
const PER_FUEL_REWARD_TYPES: ReadonlySet<DrawRewardTypeEnum> = new Set([
  DrawRewardTypeEnum.YEAR_OF_ENERGY,
])

export function rewardTypeHasCreditValue(type: DrawRewardTypeEnum): boolean {
  return CREDIT_VALUE_REWARD_TYPES.has(type)
}

export function rewardTypeHasFuelValues(type: DrawRewardTypeEnum): boolean {
  return PER_FUEL_REWARD_TYPES.has(type)
}
